export const ThemeToggle = {
  extends: 'Button',
  flow: 'x',
  gap: 'Y',
  align: 'center center',
  padding: 'Y Z',
  fontSize: 'Z',
  borderRadius: 'Z',
  cursor: 'pointer',
  background: 'surfaceBorder',
  border: '1px solid surfaceBorderStrong',
  color: 'textSoft',
  text: (el, s) => s.root.darkMode !== false ? '☀' : '☾',

  onClick: (e, el, s) => {
    const isDark = s.root.darkMode !== false
    s.root.update({ darkMode: !isDark })
    document.documentElement.setAttribute('theme', isDark ? 'light' : 'dark')
  },
}
